import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';




import {validarItem, validarFormulario} from './../utils/validar'; 
import Confirmar from '../components/ModalConfirmar'; 
import Cargando from './../components/Cargando';
import { FaSave , FaTrashAlt} from "react-icons/fa";
import Notificaciones from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';


import SelectCiclos from './../components/SelectCiclos';
import Botonera from './../components/BotoneraGuardar';
import TablaMaterial from './../components/TablaMaterial';
import Utils from './../utils/utils';
import Fecha from './../utils/fecha';
import Material from './../api/Material'; 

const material = new Material(); 

class GestorMaterial extends Component {
    _isMounted = false;
    constructor(props) {
        super(props); 
        this.state = {
            ciclo:'',
            archivo : null,
            data:[],
            titulo:'',
            descripcion:'',
            fecha: Fecha.Hoy(),
            id:'',
            usuario: this.props.user.rut,
            modal:false,

            cargando:true,
            validacion:{
                ciclo: false, 
                titulo: false,
                descripcion: false,
                archivo: false,
            },
            confirmarGuardar: false,
            confirmarEditar: false, 
            confirmarBorrar: false,
            idBorrar:''
        }
    }

    estadoDefault = () =>{
        document.getElementById('input').value = null;
        this.setState({
            ciclo:'',
            id:'',
            archivo : null,
            titulo:'',
            encabezado:'',
            descripcion:'',
            fecha: '',
            modal:false,

            cargando:true,
            validacion:{
                ciclo: false, 
                titulo: false,
                descripcion: false,
                archivo: false,
            },
            confirmarGuardar: false,
            confirmarEditar: false, 
            confirmarBorrar: false,
            idBorrar:''
        })

    }

    manejaCiclo = (evento) => {
        this.setState({ciclo: evento.target.value})
    }

    archivoSeleccionado = (e) => {
        this.setState({
            archivo: e.target.files[0],
        })
    }

    manejaCambio = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
    }




    /* funciones comunes para mensajes y validaciones */ 
    guardarEditarValidando = async ({validacion, confirmar}) =>{
        let validado = await validacion();

        if(validado.resultado){
            confirmar()
        }else{

            for (const k in validado.mensajes) {

                this.Notificaciones.addNotification({
                    message: validado.mensajes[k],
                    level: 'error',
                    position:'tr'
                });
                 
            }
    
        }  

    }

    mensajeGuardadoEditado = async ({resultado, mensaje, icono, tipo}) =>{
        if(resultado==="ok"){

            await this.cargarListado();
            this.estadoDefault();
            
            this.Notificaciones.addNotification({
                title: <FaSave/>,
                message: mensaje,
                level: 'success',
                position:'tr'
            });

        } else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });  
        }

        this.setState({cargando:false});   
    }


    validacionFormulario = async () => {
        const {ciclo, titulo, descripcion, archivo} = this.state;

        let vCiclo          = validarItem({valor:ciclo, input:'Ciclo', select:true});
        let vTitulo         = validarItem({valor:titulo, input:'Título', vacio:true, largo:80});
        let vDescripcion    = validarItem({valor:descripcion, input:'Descripcion', vacio:false, largo:200});
        let vArchivo        = validarItem({valor:archivo, input:'Archivo', archivo:true});



        this.setState({ validacion:{
            ciclo:          !vCiclo.resultado, 
            titulo:         !vTitulo.resultado,
            descripcion:    !vDescripcion.resultado,
            archivo:        !vArchivo.resultado,
        } });  
        
        let formulario = validarFormulario([vCiclo, vTitulo, vDescripcion, vArchivo]); 
 
        return formulario;

    }



    /* ingresar */

    muestraConfirmarGuardar = () => {
        this.setState(prevState => ({
            confirmarGuardar: !prevState.confirmarGuardar
        }));    
    }

    ingresarMaterial = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarGuardar   
        }); 
    }

    ingresarMaterialBD = async () =>{
        this.setState({cargando:true});

        let {ciclo, titulo, descripcion, archivo, usuario} = this.state;
        let urlpath = Utils.espacioGuion(titulo); 
        let fecha = Fecha.Hoy();

        let resultado = await material.ingresar(ciclo, titulo, urlpath, descripcion, archivo, archivo.name, fecha, usuario); 
        
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Material ingresado correctamente'})

    }



    /* editar */

     muestraConfirmarEditar = () => {
        this.setState(prevState => ({
            confirmarEditar: !prevState.confirmarEditar
        }));    
    }

    editarMaterial = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarEditar   
        }); 
    }

    editarMaterialBD = async () =>{
        this.setState({cargando:true});

        const {id, ciclo, titulo, descripcion, archivo, usuario} = this.state;
        let urlpath = Utils.espacioGuion(titulo); 
        let fecha = Fecha.Hoy();

        let resultado;
        if(archivo){
            resultado = await material.editar(id, ciclo, titulo, urlpath, descripcion, archivo, archivo.name, fecha, usuario);
        }else{
            resultado = await material.editarinfo(id, ciclo, titulo, urlpath, descripcion, fecha, usuario)
        }
        
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Material editado correctamente'})

    }

    cargarEditar = (c) => {
        let cicloNombre = c.curso; 
        let CicloId = cicloNombre!==null?c.ciclo_id:'';
        this.setState({
            id: c.id, 
            titulo: c.titulo, 
            descripcion: c.descripcion, 
            ciclo:CicloId,
            archivo:false,
            validacion:{
                ciclo: false, 
                titulo: false,
                descripcion: false,
                archivo: false,
            },
        }); 
    }


    cancelarEditar = () => {
        document.getElementById('input').value = null;
        this.setState({ 
            titulo:'', 
            descripcion:'', 
            id:'', 
            ciclo:'', 
            archivo:null,
            validacion:{
                ciclo: false, 
                titulo: false,
                descripcion: false,
                archivo: false,
            },
        }); 
    }



    /* borrar */

    muestraConfirmarBorrar = (id) => {
        this.setState((prevState) => ({
            confirmarBorrar: !prevState.confirmarBorrar,
            idBorrar: id
        }));          
    }

    eliminarMaterial = async () => {
        this.setState({cargando:true});
        
        let resultado = await material.eliminar(this.state.idBorrar)

        if(resultado==="ok"){
            await this.cargarListado();
            
            this.Notificaciones.addNotification({
                title: <FaTrashAlt/>,
                message: 'Material eliminado satisfactoriamente',
                level: 'info',
                position:'tr'
            });
        }else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });          
        }

       
        this.setState({cargando:false});
    }


    cargarListado = async () => {
        const {usuario} = this.state; 
        let resultado = await material.mostrar(usuario); 
        this.setState({data: resultado, cargando:false}); 
    }

    componentDidMount() {
        this.cargarListado();
    }

    render(){
        const {ciclo, data, titulo, descripcion, id, cargando, confirmarGuardar, confirmarEditar, confirmarBorrar, validacion} = this.state;
        return ( 
            <Page title="Administrador de material académico" breadcrumbs={[ { name: 'Material', active: true } ]}>
                <Cargando valor={cargando}/>
                <Card>
                    <CardHeader>Información del material</CardHeader>
                    <CardBody>
                    <Form>
        
                        <Row className="no-margin-bottom">
                            <Col  lg={2} md={4} sm={12}>
                                <FormGroup>
                                    <Label >Ciclo</Label>
                                    <SelectCiclos  maneja={this.manejaCiclo} ciclo={ciclo}  invalido={validacion.ciclo}/> 
                                </FormGroup>
                            </Col>
                            <Col  lg={2} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Título</Label>
                                    <Input
                                        type="text"
                                        name="titulo"
                                        value={titulo}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.titulo}
                                        maxLength={80}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  lg={4} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Descripción</Label>
                                    <Input
                                        type="text"
                                        name="descripcion"
                                        value={descripcion}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.descripcion}
                                        maxLength={200}
                                    />
                                </FormGroup>
                            </Col>

                            <Col  lg={4} md={4} sm={12}>

                                <FormGroup >
                                <Label>Archivo</Label>
                                <Input
                                    className={validacion.archivo?"in-error": null}
                                    id = "input"
                                    type="file"
                                    onChange={this.archivoSeleccionado}
                                    accept="application/pdf,application/vnd.ms-excel,
                                    application/msword,application/vnd.ms-powerpoint,
                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                                    application/vnd.oasis.opendocument.text,
                                    image/*,audio/*,video/*"
                           
                                />
                                </FormGroup>
                            </Col>
                        </Row>      
                    </Form>
                    </CardBody>
                    <Botonera 
                        valor={id}
                        ingresar={this.ingresarMaterial}
                        editar={this.editarMaterial}
                        cancelar={this.cancelarEditar}
                    />
                </Card>
                <br/>
                <TablaMaterial
                    data={data}
                    editar={this.cargarEditar}
                    eliminar={this.muestraConfirmarBorrar}
                    cargarListado={this.cargarListado}
                />   


                <Confirmar 
                    isOpen={confirmarGuardar} 
                    toggle={this.muestraConfirmarGuardar} 
                    texto={"¿Esta seguro de guardar el material?"} 
                    funcion={this.ingresarMaterialBD} 
                />

                 <Confirmar 
                    isOpen={confirmarEditar} 
                    toggle={this.muestraConfirmarEditar} 
                    texto={"¿Esta seguro de editar el material?"} 
                    funcion={this.editarMaterialBD} 
                />

                 <Confirmar 
                    isOpen={confirmarBorrar} 
                    toggle={this.muestraConfirmarBorrar} 
                    texto={"¿Esta seguro de borrar el material?"} 
                    funcion={this.eliminarMaterial} 
                />


                <Notificaciones
                    dismissible={false}
                    ref={Notificaciones =>
                        (this.Notificaciones = Notificaciones)
                    }
                    style={NOTIFICATION_SYSTEM_STYLE}
                    />





            </Page>
        );
    };
}
export default GestorMaterial;
